import React from 'react';
import styles from "./TextToolTip.module.scss";

const TextToolTip = ({frontText, insideText}) => {


    return ( 
        <div className={styles.tooltip}>{frontText}
          <span className={styles.tooltiptext}>{insideText}</span>
        </div>
    )
}

export default TextToolTip;